import {Injectable} from "@angular/core";
import { HttpClient } from '@angular/common/http';


@Injectable({
    providedIn: 'root',
})
export class AssetsService {
    private userData: any;

    constructor(
        private http: HttpClient
    ) {}

    getIconsSVG(urlSVG: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.http.get(urlSVG, { responseType: 'blob' })
                .subscribe({
                    next: (blob) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            const base64 = reader.result as string;  // Convert Blob to Base64
                            resolve(base64);  // Return the value
                        };
                        reader.onerror = reject; // Handle error
                        reader.readAsDataURL(blob);
                    },
                    error: reject
                });
        });
    }
}
